<template>
  <div v-if="sections">
    <div
      style="margin-top:5px;"
      v-for="(section, parent_node_index) in sections"
      :key="parent_node_index + 1"
    >
      <template>
        <BlocGabaritSection :indexSection="parent_node_index" />
        <draggable
          @change="resetAllOptionsQuestion(sections[parent_node_index])"
          group="questions"
          :list="sections[parent_node_index].questions"
          handle=".handle-question"
        >
          <template v-for="(question, index) in section.questions">
            <BlocGabaritQuestion
              :class="activeCssClickedDragIcon ? 'ghost' : ''"
              :key="index"
              :question="question"
              :indexQuestion="index"
              :indexSection="parent_node_index"
            ></BlocGabaritQuestion>
          </template>
        </draggable>
        <AddQuestionButton :indexSection="parent_node_index" />
      </template>
    </div>
  </div>
</template>

<script>
import BlocGabaritQuestion from '@/components/question/BlocGabaritQuestion'
import BlocGabaritSection from '@/components/question/section/BlocGabaritSection'
import AddQuestionButton from '@/components/question/components/AddQuestionButton'
import draggable from 'vuedraggable'
import { mapGetters } from 'vuex'
import EventBus from '@/eventBus'

export default {
  components: {
    BlocGabaritQuestion,
    draggable,
    AddQuestionButton,
    BlocGabaritSection
  },
  data () {
    return {
      dragDisabled: true,
      dragDisabledSection: true,
      message: false,
      showOnePopup: true,
      activeCssClickedDragIcon: false
    }
  },
  created () {
    EventBus.$on('clickedDragIcon', this.changeCssClickedDragIcon)
  },
  updated () {
    this.$nextTick(function () {
      let message = {
        height: document.body.scrollHeight
      }
      window.top.postMessage(message, '*')
    })
  },
  computed: {
    ...mapGetters(['type_formulaire']),
    sections: {
      get: function () {
        return this.$store.state.question.sections
      }
    }
  },
  methods: {
    sendMessageToParent (taskToDo) {
      let message = {
        task: taskToDo
      }
      window.top.postMessage(message, '*')
    },
    changeCssClickedDragIcon (value) {
      this.activeCssClickedDragIcon = value
    },
    resetQuestion (question) {
      this.showOnePopup = false
      this.sendMessageToParent('scrollToTop')
      this.$buefy.dialog.confirm({
        title: this.$i18n.t('popup.reinitialisation.questions.titre'),
        message: this.$i18n.t('popup.reinitialisation.questions.texte'),
        confirmText: 'OK',
        canCancel: 'false',
        type: 'is-danger',
        /* cancelText: this.$i18n.t('button.annuler'), */
        hasIcon: true,
        /* onCancel: () =>
          this.$store.commit('RESET_CHANGE_ORDER_QUESTION', {
            question: question
          }), */
        onConfirm: () =>
          this.$store.commit('RESET_ALL_OPTIONS_DRAG', {
            type: 'question',
            data: question
          })
      })
    },
    resetAllOptionsQuestion (section) {
      // on pousse les ids des sections dans un array
      this.showOnePopup = true
      let arrayOfIds = []
      this.sections.forEach(section => {
        arrayOfIds.push(section.id)
      })
      section.questions.forEach((question, indexQuestion) => {
        question.answers.forEach((answer, indexAnswer) => {
          if (this.showOnePopup) {
            if (
              section.order >= arrayOfIds.indexOf(answer.conditional_section) &&
              answer.conditional_section !== undefined &&
              answer.conditional_section !== null &&
              answer.conditional_section !== -1
            ) {
              this.resetQuestion(section.questions[indexQuestion])
              this.showOnePopup = false
            }
          }
        })
      })
    }
  }
}
</script>
<style scoped>
.ghost:active {
  background: #d8d8d8;
  color: black;
  opacity: 0.3;
}
</style>



// WEBPACK FOOTER //
// src/components/question/section/draggable/draggableFormSection.vue